import { createFileRoute } from "@tanstack/react-router"
import { useTranslation } from "react-i18next"

import { Button, LinkButton } from "@/globalComponents/atoms/Button"
import Card from "@/globalComponents/atoms/Card"
import Heading from "@/globalComponents/atoms/Heading"
import Icon from "@/globalComponents/atoms/Icon"
import Separator from "@/globalComponents/atoms/Separator"
import Text from "@/globalComponents/atoms/Text"

import styles from "./expired.module.css"

export const Route = createFileRoute(
  "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month/$day/cart/expired"
)({
  staticData: {
    pageName: "Reservation Timeout",
  },
  validateSearch: (search: Record<string, unknown>) => ({
    reason: (search.reason as "holdExpired" | "windowEnded") || "holdExpired",
  }),
  component: RouteComponent,
})

function RouteComponent() {
  const navigate = Route.useNavigate()
  const { qrLookupID } = Route.useParams()
  const { reason } = Route.useSearch()
  const { t } = useTranslation("reserve")

  return (
    <div className={styles.container}>
      <Card>
        <div className={styles.iconRow}>
          <Icon name="clock" className={styles.clockIcon} />
          <Heading level={1} as={2} className="center">
            {t("reservationTimeout.heading")}
          </Heading>
        </div>
        <Separator orientation="horizontal" />
        <Text level={1} className="center">
          {t(reason === "windowEnded" ? "reservationTimeout.bodyWindowEnded" : "reservationTimeout.body")}
        </Text>
        <Button
          buttonType="primary"
          onPress={() =>
            navigate({
              to: "/qr/$qrLookupID/reserve/$epoch/calendars/$calendarID/dates/$year/$month/$day/rates",
            })
          }
        >
          {t("reservationTimeout.returnToRates")}
        </Button>
        <Text level={3} className="center">
          {t("reservationTimeout.needHelp")}{" "}
          <LinkButton
            buttonType="primary"
            presentation="link"
            to="/qr/$qrLookupID/help"
            params={{ qrLookupID }}
            style={{ textDecoration: "underline" }}
          >
            {t("reservationTimeout.clickHere")}
          </LinkButton>
        </Text>
      </Card>
    </div>
  )
}
